import { Col } from "react-bootstrap";
import SmartField from "../../../../rhf/smartfield";
import React from "react";
import * as yup from 'yup';
import { isDate,parse } from "date-fns";

export const GetHoldTillValidationSchema = (formValues,lookupData) => {
    function parseDateString(value, originalValue) {
        const parsedDate = isDate(originalValue)
            ? originalValue
            : parse(originalValue, "yyyy-MM-dd", new Date());
        return parsedDate;
    }

    const base = {
        holdtilldate: yup
            .date()
            .typeError("*Required")
            .required('*Required')
            .transform(parseDateString)
            .min(new Date().toISOString().split('T')[0], '*Date cannot be in the past.')
    }

    return base;
    
}

const HoldTillFields = ({register,control,errors}) => {
    return(
        <>
            <Col xs={12}>
                <strong className="d-flex justify-content-center">Hold Untill Information</strong>
            </Col>
            <Col xs={12} md={6}>
                <SmartField
                    label='Hold Till Date'
                    name='holdtilldate'
                    type='date'
                    style={{width: '100%'}}
                    register={register}
                    errors={errors}
                    min={new Date().toISOString().split('T')[0]}
                />
            </Col>
        </>
    )
}

export default HoldTillFields;